import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import logo from "../assets/logo.png";
import googleLogo from "../assets/google-logo.png"; // Google logo image
import "./styles/LoginPage.css";
import WebsiteFooter from "../components/WebsiteFooter";

const Login = ({ setLoggedInUser }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (firebase.auth().currentUser?.uid) {
      setLoggedInUser(firebase.auth().currentUser.uid);
      navigate("/");
    }
  }, [setLoggedInUser, navigate]);

  // Check if email exists in Firebase Auth
  const checkEmailExists = async (email) => {
    try {
      const methods = await firebase.auth().fetchSignInMethodsForEmail(email);
      return methods.length > 0; // Email exists if methods array is not empty
    } catch (error) {
      console.error("Error checking email:", error);
      return false;
    }
  };

  // Handle Login or Sign Up
  const handleAuth = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setErrorMessage("Please fill out all fields.");
      return;
    }

    const emailExists = await checkEmailExists(email);

    if (emailExists) {
      // Proceed with Login
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((userCredential) => {
          const loggedInUser = userCredential.user.uid;
          setLoggedInUser(loggedInUser);
          window.gtag("event", "login", {
            event_category: "email/password",
            event_label: "logged_in",
          });
          navigate("/");
        })
        .catch((error) => {
          setErrorMessage("Invalid email or password.");
          console.error("Login Error:", error);
        });
    } else {
      // Proceed with Sign Up
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then((userCredential) => {
          const loggedInUser = userCredential.user.uid;
          setLoggedInUser(loggedInUser);
          window.gtag("event", "sign_up", {
            event_category: "email/password",
            event_label: "signed_up",
          });
          navigate("/");
        })
        .catch((error) => {
          setErrorMessage("Failed to create account.");
          console.error("Sign-Up Error:", error);
        });
    }
  };

  // Handle Google Login
  const handleGoogleLogin = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        const loggedInUser = result.user.uid;
        setLoggedInUser(loggedInUser);
        navigate("/");
      })
      .catch((error) => {
        setErrorMessage(error.message);
        console.error("Google Login Error:", error);
      });
  };

  return (
    <>
      <div className="loginPage">
        <div className="loginBox">
          <img src={logo} alt="logo" className="logo1" />
          <div className="loginContainer">
            <h1 className="logintitle">Login / Sign Up</h1>

            {/* Google Login */}
            <div className="google-login">
              <button onClick={handleGoogleLogin}>
                <img src={googleLogo} alt="Google Logo" className="google-logo" />
                Continue with Google
              </button>
            </div>

            {/* Email/Password Form */}
            <form className="login-input" onSubmit={handleAuth}>
              <input
                className="col-10"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                className="col-10"
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className="login-button">
                <button type="submit">
                  Login
                </button>
              </div>
            </form>

            {errorMessage && (
              <p className="text-danger" style={{ fontSize: "100%" }}>
                {errorMessage}
              </p>
            )}
          </div>
        </div>
      </div>
      <WebsiteFooter />
    </>
  );
};

export default Login;
